import { Button } from 'react-bootstrap';
import './styles.scss';
import { useActivityContext } from '@company/state/activityContext';
import { JobAssignment } from '@th-types/job.detail.type';

interface ButtonMarkAllOnboardingAsCompletedProps {
  jobAssignments: JobAssignment[];
}

export default function ButtonMarkAllOnboardingAsCompleted({
  jobAssignments,
}: ButtonMarkAllOnboardingAsCompletedProps) {
  const { completeOnboardingAction } = useActivityContext();

  return (
    <Button
      variant="light"
      size="sm"
      disabled={jobAssignments.every((item) => item.onBoardingCompleted)}
      onClick={() => completeOnboardingAction(jobAssignments)}
    >
      MARK ALL AS ONBOARDED
    </Button>
  );
}
